import 'core-js/modules/es.array.iterator.js';
import 'core-js/modules/web.dom-collections.iterator.js';
import 'core-js/modules/es.object.assign.js';
import { __awaiter } from '../../../_virtual/_tslib.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Stack, Text, TextField } from '@hub-la/design-system';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import NumberFormat from 'react-number-format';
import 'react-phone-number-input/style.css';
import { useField } from '../hooks/use-field.js';
import { UF } from '../../domain/constants/brazilian-states.js';
import { Autocomplete } from '@mui/material';
import { useEffect } from 'react';
import { useGetAddress } from '../hooks/use-get-postal-code.js';

const BillingAddressForm = () => {
  var _a;
  const {
    values,
    handleBlur,
    handleChange,
    setFieldValue
  } = useFormikContext();
  const getAddressUseCase = useGetAddress();
  const fetchAdress = postalCode => __awaiter(void 0, void 0, void 0, function* () {
    const address = yield getAddressUseCase.execute(postalCode);
    if (!address) {
      return;
    }
    setFieldValue('billingAddress.street', address.street);
    setFieldValue('billingAddress.neighborhood', address.neighborhood);
    setFieldValue('billingAddress.state', address.state);
    setFieldValue('billingAddress.city', address.city);
  });
  useEffect(() => {
    fetchAdress(values.billingAddress.postalCode);
  }, [values.billingAddress.postalCode]);
  const {
    hasError,
    getErrorText
  } = useField();
  const {
    t
  } = useTranslation();
  return jsxs(Stack, Object.assign({
    direction: "column",
    spacing: 4
  }, {
    children: [jsx(Stack, Object.assign({
      direction: "row",
      spacing: 1
    }, {
      children: jsx(Text, {
        children: t('accountVerification.form.billingAddress.title')
      })
    })), jsxs(Stack, Object.assign({
      direction: "column",
      spacing: 4
    }, {
      children: [jsx(NumberFormat, {
        error: hasError('billingAddress.postalCode'),
        helperText: getErrorText('billingAddress.postalCode'),
        onBlur: handleBlur,
        onChange: handleChange,
        value: values.billingAddress.postalCode,
        type: "tel",
        id: "billingAddress.postalCode",
        format: "#####-###",
        customInput: TextField,
        size: "normal",
        label: t('accountVerification.form.billingAddress.postalCode')
      }), jsx(TextField, {
        error: hasError('billingAddress.neighborhood'),
        helperText: getErrorText('billingAddress.neighborhood'),
        onBlur: handleBlur,
        onChange: handleChange,
        value: values.billingAddress.neighborhood,
        type: "text",
        id: "billingAddress.neighborhood",
        size: "normal",
        label: t('accountVerification.form.billingAddress.neighborhood'),
        fullWidth: true
      }), jsx(TextField, {
        error: hasError('billingAddress.street'),
        helperText: getErrorText('billingAddress.street'),
        onBlur: handleBlur,
        onChange: handleChange,
        value: values.billingAddress.street,
        type: "text",
        id: "billingAddress.street",
        size: "normal",
        label: t('accountVerification.form.billingAddress.street'),
        fullWidth: true
      }), jsxs(Stack, Object.assign({
        direction: "row",
        spacing: 4,
        flexShrink: 1
      }, {
        children: [jsx(TextField, {
          error: hasError('billingAddress.number'),
          helperText: getErrorText('billingAddress.number'),
          onBlur: handleBlur,
          onChange: handleChange,
          value: values.billingAddress.number,
          type: "text",
          id: "billingAddress.number",
          fullWidth: true,
          size: "normal",
          label: t('accountVerification.form.billingAddress.number')
        }), jsx(TextField, {
          error: hasError('billingAddress.complement'),
          helperText: getErrorText('billingAddress.complement'),
          onBlur: handleBlur,
          onChange: handleChange,
          value: values.billingAddress.complement,
          type: "text",
          id: "billingAddress.complement",
          fullWidth: true,
          size: "normal",
          label: t('accountVerification.form.billingAddress.complement')
        })]
      })), jsxs(Stack, Object.assign({
        direction: "row",
        spacing: 4
      }, {
        children: [jsx(TextField, {
          error: hasError('billingAddress.city'),
          helperText: getErrorText('billingAddress.city'),
          onBlur: handleBlur,
          onChange: handleChange,
          value: values.billingAddress.city,
          type: "text",
          id: "billingAddress.city",
          fullWidth: true,
          size: "normal",
          label: t('accountVerification.form.billingAddress.city')
        }), jsx(Autocomplete, {
          value: (_a = UF.find(uf => uf.code === values.billingAddress.state)) !== null && _a !== void 0 ? _a : null,
          onChange: (_e, value) => setFieldValue('billingAddress.state', value === null || value === void 0 ? void 0 : value.code),
          fullWidth: true,
          size: "medium",
          getOptionLabel: option => option.code + ' - ' + option.name,
          renderInput: params => jsx(TextField, Object.assign({}, params, {
            error: hasError('billingAddress.state'),
            helperText: getErrorText('billingAddress.state'),
            label: t('accountVerification.form.billingAddress.state')
          })),
          options: UF
        })]
      }))]
    }))]
  }));
};

export { BillingAddressForm };
